import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AuthClient from "../api/AuthClient";
import Header from "../components/Header";
import LoginPage from "../components/Login";

const Login = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const authClient: AuthClient = new AuthClient();
    if (authClient.isLoggedIn()) {
      navigate("/");
    }
  });

  return (
    <>
      <Header />
      <LoginPage />
    </>
  );
};

export default Login;
